<template>
  <div>
    <chart
      v-if="data.loaded && data.labels.length"
      :chart-data="chartData"
      :chart-options="chartOptions"
    />
    <b-alert
      v-else
      show
      variant="warning"
      class="w-50 mx-auto text-center"
    >
      There's no data to show
    </b-alert>
  </div>
</template>
<script>
import Chart from '@/modules/reporting/components/Chart.vue';

const toLocaleString = (number, withDecimals) => (withDecimals ? number.toLocaleString(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})
  : number.toLocaleString());
let currencySymbol = '$';

export default {
  name: 'DeliveryChart',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: {
    Chart,
  },
  data() {
    return {
      chartData: {
        labels: this.data.labels,
        datasets: [
          {
            type: 'line',
            label: 'CTR%',
            backgroundColor: '#0D74CE',
            borderColor: '#0D74CE',
            pointBackgroundColor: '#0D74CE',
            pointBorderColor: '#0D74CE',
            fill: false,
            borderWidth: 2,
            lineTension: 0.3,
            data: this.data.ctr,
            yAxisID: 'ctr-axis',
            ticks: {
              beginAtZero: true,
            },
          },
          {
            type: 'line',
            label: 'STR%',
            backgroundColor: '#8E0DCE',
            borderColor: '#8E0DCE',
            pointBackgroundColor: '#8E0DCE',
            pointBorderColor: '#8E0DCE',
            fill: false,
            borderWidth: 2,
            lineTension: 0.3,
            data: this.data.str,
            yAxisID: 'str-axis',
            ticks: {
              beginAtZero: true,
            },
          },
          {
            type: 'bar',
            label: 'IMPRESSIONS',
            backgroundColor: '#2AC779',
            hoverBackgroundColor: '#297050',
            data: this.data.impressions,
            yAxisID: 'impressions-axis',
          },
          {
            type: 'bar',
            label: 'COST',
            backgroundColor: '#9DDAE6',
            hoverBackgroundColor: '#296673',
            data: this.data.cost,
            yAxisID: 'cost-axis',
          },
        ],
      },
      chartOptions: {
        scales: {
          yAxes: [
            {
              id: 'impressions-axis',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
                callback(value) {
                  return toLocaleString(value);
                },
              },
              gridLines: {
                color: '#ceced5',
              },
              scaleLabel: {
                display: true,
                labelString: 'IMPRESSIONS',
              },
            },
            {
              id: 'cost-axis',
              type: 'linear',
              display: true,
              position: 'right',
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: false,
                color: '#ceced5',
              },
              scaleLabel: {
                display: true,
                labelString: 'COST',
              },
            },
            {
              id: 'ctr-axis',
              display: false,
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: '#ceced5',
              },
            },
            {
              id: 'str-axis',
              display: false,
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                color: '#ceced5',
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                autoSkip: false,
                maxRotation: 40,
                minRotation: 40
              }
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          reverse: true,
          position: 'bottom',
          labels: {
            boxWidth: 12,
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label(tooltipItem, data) {
              const event = data.datasets[tooltipItem.datasetIndex].label;
              const getModifiedValues = (eventName, value) => {
                if (eventName === 'COST') return `${currencySymbol + toLocaleString(value, true)}`;
                if (eventName !== 'IMPRESSIONS') return toLocaleString(value, true);
                return toLocaleString(value);
              };
              return `${event}: ${getModifiedValues(event, tooltipItem.yLabel)}`;
            },
          },
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
      },
    };
  },
  methods: {
    removeStrFromChart() {
      const datasetsIndex = this.chartData.datasets.findIndex((item) => item.label.includes('STR'));
      this.chartData.datasets.splice(datasetsIndex, 1);
    },
  },
  created() {
    if (!this.data.str.length) {
      this.removeStrFromChart();
    }
    // eslint-disable-next-line prefer-destructuring
    currencySymbol = this.data.currencySymbol;
  },
};
</script>
<style>
</style>
